
export class Anulacions {
  listAnulacions: any[];
  fechaInicio: Date;
  fechaFin: Date;
}
